import { useEffect, useState, useMemo } from 'react';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import FlightsListView from './FlightsListView';
import FlightsAsideFilters from 'legacyfrontend/components/flights/AsideFilters/FlightsAsideFilter';
import MobileFlightsFilter from 'legacyfrontend/components/flights/AsideFilters/MobileAsideFilters';
import { Stack } from '@mui/material';
import { FlightsFiltersProvider } from 'legacyfrontend/contexts/FlightsFiltersContext';
import { FlightProvider } from 'legacyfrontend/contexts/FlightDetailsContext';
import SearchSelector from '../../../components/home/components/SearchSelector';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import { useLocation } from 'react-router-dom';

const FlightListPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { onSearchCount } = useGlobal();
  const { search } = useLocation();

  const hasValidSearchParams = useMemo(() => {
    if (!search) return false;

    const searchParams = new URLSearchParams(search);
    const hasOrigin = searchParams.get('originId') && searchParams.get('originName');
    const hasDestination = searchParams.get('destinationId') && searchParams.get('destinationName');
    const hasDates = searchParams.get('departureDate');

    return hasOrigin && hasDestination && hasDates;
  }, [search]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isClient ? window.innerWidth <= 768 : false);
    };
    handleResize();
    isClient && window.addEventListener('resize', handleResize);
    return () => isClient && window.removeEventListener('resize', handleResize);
  }, []);

  const shouldShowFilters = onSearchCount > 0 || hasValidSearchParams;

  return (
    <FlightProvider>
      <FlightsFiltersProvider>
        <SearchSelector isOnTargetPath />
        {shouldShowFilters && (
          <Stack
            direction='row'
            display='flex'
            sx={{
              padding: '4vw 4vw 0 4vw',
              marginBottom: '3rem',
            }}
          >
            {!isMobile ? (
              <FlightsAsideFilters />
            ) : (
              shouldShowFilters && (
                <MobileFlightsFilter>
                  <FlightsAsideFilters isMobile />
                </MobileFlightsFilter>
              )
            )}
            {shouldShowFilters && <FlightsListView />}
          </Stack>
        )}
      </FlightsFiltersProvider>
    </FlightProvider>
  );
};

export default FlightListPage;
